/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Error_Has_Open_OrdersInputs */

const vi_trip_error_has_open_orders = /** @type {(inputs: Trip_Error_Has_Open_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn đơn chưa giao xong`)
};

/**

* @param {Trip_Error_Has_Open_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_error_has_open_orders = /** @type {((inputs?: Trip_Error_Has_Open_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Error_Has_Open_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_error_has_open_orders(inputs)
});